import {
  SECTION_REGISTRY as DEFAULT_SECTION_REGISTRY,
  DEFAULT_SECTION_ORDER as DEFAULT_SECTION_ORDER_DEFAULT,
  PAGES as DEFAULT_PAGES,
  ROUTES as DEFAULT_ROUTES,
  SHARED_EXTENSIONS as DEFAULT_EXTENSIONS,
} from "./default/registry";
import {
  SECTION_REGISTRY as AGENCE_V1_SECTION_REGISTRY,
  DEFAULT_SECTION_ORDER as AGENCE_V1_SECTION_ORDER,
  CHROME as AGENCE_V1_CHROME,
  PAGES as AGENCE_V1_PAGES,
  ROUTES as AGENCE_V1_ROUTES,
  SHARED_EXTENSIONS as AGENCE_V1_EXTENSIONS,
} from "./agence_v1/registry";
import {
  SECTION_REGISTRY as COUTURE_V1_SECTION_REGISTRY,
  DEFAULT_SECTION_ORDER as COUTURE_V1_SECTION_ORDER,
  CHROME as COUTURE_V1_CHROME,
  PAGES as COUTURE_V1_PAGES,
  ROUTES as COUTURE_V1_ROUTES,
  SHARED_EXTENSIONS as COUTURE_V1_EXTENSIONS,
} from "./couture_v1/registry";
import { mergeSectionRegistry } from "./shared";

// Sections PARTAGÉES (voir themes/shared.js et, côté serveur,
// theme_engines/shared_sections.py) : le registre de chaque moteur est
// composé ici — ses propres sections, plus celles des autres moteurs sous
// leur type préfixé (« agence_hero », « base_faq_section »…), plus ses
// extensions. Les registres propres (<moteur>/registry.js) restent purs.
const OWN_SECTION_REGISTRIES = {
  default: DEFAULT_SECTION_REGISTRY,
  agence_v1: AGENCE_V1_SECTION_REGISTRY,
  couture_v1: COUTURE_V1_SECTION_REGISTRY,
};

// Dispatch entre moteurs de thème — isolation totale par dossier (voir
// /home/codespace/.claude/plans/curried-wondering-pumpkin.md). Chaque
// moteur vit dans son propre frontend/src/themes/<moteur>/ (composants +
// registre), totalement indépendant des autres : ajouter un moteur
// n'exige JAMAIS de modifier un fichier appartenant à un moteur existant,
// seulement d'ajouter une entrée ici (symétrique de
// backend/services/theme_engines/__init__.py).
export const DEFAULT_ENGINE = "default";

const ENGINE_REGISTRIES = {
  // `CHROME` absent = en-tête/pied de page PARTAGÉS (components/Header.jsx
  // et components/Footer.jsx), c'est-à-dire le comportement d'origine et
  // celui de toutes les boutiques existantes. Un moteur ne le déclare que
  // s'il rend lui-même ces deux régions.
  //
  // `PAGES` : pages hors sections dessinées par le moteur (aujourd'hui la
  // confirmation d'envoi du formulaire de contact, voir
  // pages/ContactConfirmation.jsx). Une page absente retombe sur celle du
  // moteur "default".
  //
  // `ROUTES` : pages de SECTIONS du moteur — chemin public → template
  // (voir pages/EnginePage.jsx, monté en route attrape-tout dans App.js) :
  // ses pages propres et la page PARTAGÉE par tous les moteurs
  // (/confidentialite, voir backend theme_engines/shared_pages.py). Absent
  // = le moteur n'a que les pages génériques (accueil, boutique, produit,
  // panier).
  default: {
    SECTION_REGISTRY: mergeSectionRegistry("default", OWN_SECTION_REGISTRIES, DEFAULT_EXTENSIONS),
    DEFAULT_SECTION_ORDER: DEFAULT_SECTION_ORDER_DEFAULT,
    PAGES: DEFAULT_PAGES,
    ROUTES: DEFAULT_ROUTES,
  },
  agence_v1: {
    SECTION_REGISTRY: mergeSectionRegistry("agence_v1", OWN_SECTION_REGISTRIES, AGENCE_V1_EXTENSIONS),
    DEFAULT_SECTION_ORDER: AGENCE_V1_SECTION_ORDER,
    CHROME: AGENCE_V1_CHROME,
    PAGES: AGENCE_V1_PAGES,
    ROUTES: AGENCE_V1_ROUTES,
  },
  couture_v1: {
    SECTION_REGISTRY: mergeSectionRegistry("couture_v1", OWN_SECTION_REGISTRIES, COUTURE_V1_EXTENSIONS),
    DEFAULT_SECTION_ORDER: COUTURE_V1_SECTION_ORDER,
    CHROME: COUTURE_V1_CHROME,
    PAGES: COUTURE_V1_PAGES,
    ROUTES: COUTURE_V1_ROUTES,
  },
};

// Un moteur absent/inconnu (thème jamais migré, ou valeur corrompue) retombe
// silencieusement sur "default" — jamais un écran cassé, même garantie de
// "zéro régression" que le dispatch côté serveur (voir
// theme_service._engine_of).
export function getRegistryFor(engine) {
  return ENGINE_REGISTRIES[engine] || ENGINE_REGISTRIES[DEFAULT_ENGINE];
}

// La page de sections du moteur servie à ce chemin, ou `null`. Le slash
// final est ignoré (« /savoir-faire/ » = « /savoir-faire »).
export function getEngineRoute(engine, pathname = "") {
  const routes = getRegistryFor(engine).ROUTES;
  if (!routes) return null;
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return routes[path] || null;
}
